"use client";

import { Dialog } from "@hubble/web";
import DownloadAppModal from "./DownloadAppModal";
import DownloadAppCTA from "./DownloadAppCTA";

function DesktopAndTabletDownloadAppCTA() {
  return (
    <Dialog>
      <Dialog.Trigger asChild>
        <DownloadAppCTA />
      </Dialog.Trigger>
      <DownloadAppModal />
    </Dialog>
  );
}

export default DesktopAndTabletDownloadAppCTA;
